// extracted by mini-css-extract-plugin
export default {"contacts":"Contacts_contacts__rZDmw","contactsVideo":"Contacts_contactsVideo__ORVJv","imageBox":"Contacts_imageBox__XDksX","button":"Contacts_button__RDSV0"};